import type { SentryErrorBoundaryProps } from '@platform/core/sentry/sentry-error-boundary';
import { SentryErrorBoundary } from '@platform/core/sentry/sentry-error-boundary';

import { ErrorDataUnavailable } from '@packages/fenrir/feedback/errors/error-data-unavailable';

type ErrorBoundaryProps = Omit<SentryErrorBoundaryProps, 'fallback'> & {
  fallback?: SentryErrorBoundaryProps['fallback'];
};

export const ErrorBoundary = ({
  fallback = <ErrorDataUnavailable />,
  ...props
}: ErrorBoundaryProps) => {
  return <SentryErrorBoundary fallback={fallback} {...props} />;
};
